import React from 'react';
import rules from '../../rules';
import { checkAuthorization } from '../../_helpers';

const Authorized = ({ yes, no = () => null, user, restricted, data, ...props }) => {

    return checkAuthorization(user, restricted, data) ? yes(props) : no(props);
}

export default Authorized;